// extracted by mini-css-extract-plugin
module.exports = {"statusMessage":"style-module__statusMessage___2-Xvb","content":"style-module__content___327gk","spinner":"style-module__spinner___3FOzZ"};